import "./App.css";
import Map from "./Map";
import { useState } from "react";
import { StagingLogin } from "./staging/auth";
import ReactGA from "react-ga4";
import posthog from "posthog-js";
import { FiltersContext, useFilters } from "hooks/useFilters";
import { LayerBounceContext, useLayerBounce } from "layers/layer-bounce";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

ReactGA.initialize("G-5XWHH710GF", {
  testMode: process.env.NODE_ENV !== "production",
});

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
});

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      console.error(`Something went wrong, please try again`);
      posthog.captureException(error);
    },
  }),
});

function App() {
  const [authed, setAuthed] = useState(false);

  const { filtersOn, setFiltersOn, activeFilters, activeFiltersRef } =
    useFilters();

  const { layerGroupSelectedFrom, setLayerGroupSelectedFrom } =
    useLayerBounce();

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#ffffff",
              color: "#003c6c",
              border: "2px solid #003c6c",
              borderRadius: "100px",
              fontFamily: "Roboto, sans-serif",
              fontSize: "1rem",
              padding: "10px 12px 10px 24px",
              zIndex: 9,
            },
            duration: 8000,
          }}
        />
        {process.env.REACT_APP_USE_SITE_GATING === "true" && !authed ? (
          <StagingLogin setAuthed={setAuthed} />
        ) : (
          <FiltersContext.Provider
            value={{
              filtersOn,
              setFiltersOn,
              activeFilters,
              activeFiltersRef,
            }}
          >
            <LayerBounceContext.Provider
              value={{
                layerGroupSelectedFrom,
                setLayerGroupSelectedFrom,
              }}
            >
              <Map />
            </LayerBounceContext.Provider>
          </FiltersContext.Provider>
        )}
      </div>
    </QueryClientProvider>
  );
}

export default App;
